import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { VerificationProps } from "./types";

const Verification = ({ isAuthenticatorType }: VerificationProps) => {
    const { t } = useTranslation();

    const codeRequired = t("Auth##account verification##code required");

    const checkAuthType = t(
        `Auth##account verification##check ${isAuthenticatorType ? "autheticator" : "email"}`
    );

    const enterCodeBelow = t("Auth##account verification##enter code below");
    const mainText = `${codeRequired} ${checkAuthType} ${enterCodeBelow}`;

    return (
        <>
            {mainText}

            {!isAuthenticatorType && (
                <p
                    css={css({
                        margin: "8px 0 0 0"
                    })}
                >
                    {t("Auth##account verification##code valid")}
                </p>
            )}
        </>
    );
};

export default Verification;
